import React from 'react';
import parse from 'html-react-parser';
import MoreBtn from '../ui/MoreBtn';

export default function ScheduleSessionCard({
  id,
  title,
  lesson_status,
  program_link,
  program_title,
  recepient_name,
  recepient_image,
  session_room_link,
  more_actions,
}) {
  return (
    <div className="ibox schedule-lesson-card">
      <div className="ibox-content relative">
        <div className="row">
          <div className="col-xs-12">
            <div className="title text-in-one-string without-margin full-width">
              {title}
            </div>
          </div>
          <div className="col-md-8">
            <div className="coach-info mt10 text-in-one-string flex">
              {session_room_link ? (
                <>
                  <a target="_blank" href={decodeURI(session_room_link)} rel="noreferrer">
                    <img
                      src={recepient_image}
                      className="pull-left main-image img-circle"
                      alt="avatar"
                    />
                  </a>
                  <a
                    target="_blank"
                    href={decodeURI(session_room_link)}
                    className="green"
                    rel="noreferrer"
                  >
                    {recepient_name}
                  </a>
                </>
              ) : (
                <>
                  <span>
                    <img
                      src={recepient_image}
                      className="pull-left main-image img-circle"
                      alt="avatar"
                    />
                  </span>
                  <span
                    className="green"
                  >
                    {recepient_name}
                  </span>
                </>
              )}
            </div>
            <div className="mt10 lesson-info text-in-one-string">
              Duration
              <strong>50 minutes</strong>
            </div>
            <div className="mt10 lesson-info text-in-one-string">
              Status
              <strong className="session-status">{parse(lesson_status)}</strong>
            </div>
            <div className="mt10 lesson-info text-in-one-string">
              Program
              <strong className="green">
                <a target="_blank" href={decodeURI(program_link)} rel="noreferrer">
                  {program_title}
                </a>
              </strong>
            </div>
          </div>
          <div className="col-md-4 session-card-right-action-btn">
            <a
              className="btn btn-green coaching-plan-step-to-calendar mt10 width-120"
              data-step-id={id}
              data-lesson-id="0"
            >
              Schedule
            </a>
            <MoreBtn more_actions={more_actions} />
          </div>
        </div>
      </div>
    </div>
  );
}
